import * as React from 'react';

import { Error, Lookup, Main, P2P, Success, Transfer, TransferConfirm } from 'pages';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';

import { paths } from 'routing';

export const Router = () => {
  return (
    <HashRouter>
      <Switch>
        <Route path={paths.p2p} component={P2P} exact />
        <Route path={paths.transfer} component={Transfer} exact />
        <Route path={paths.transferConfirm} component={TransferConfirm} exact />
        <Route path={paths.success} component={Success} exact />
        <Route path={paths.error} component={Error} exact />
        <Route path={paths.lookup} component={Lookup} exact />
        <Route path={paths.main} component={Main} exact />
        <Redirect to={paths.main} />
      </Switch>
    </HashRouter>
  );
};
